module.exports = __webpack_public_path__ + "img/2024-23.a3502477.jpg";